<header class="fl-navbar app-header">
  <a class="fl-navbar__brand" routerLink="/launchpad" aria-label="FORLAB home">
    <span class="fl-navbar__logo">
      <img src="assets/images/forelab-icon.png" alt="" />
    </span>
    <span class="fl-navbar__brand-text">
      <strong>FORLAB</strong>
      <small>Supply intelligence</small>
    </span>
  </a>

  <nav class="fl-navbar__actions" aria-label="Application navigation">
    <button class="fl-navbar__search" type="button" (click)="openCommandPalette()" aria-label="Search pages and commands">
      <mat-icon aria-hidden="true">search</mat-icon>
      <span>Search workspace</span>
      <span class="fl-navbar__shortcut" aria-hidden="true">Ctrl K</span>
    </button>

    <button *ngIf="showHomeButton" class="fl-navbar__icon" type="button" routerLink="/launchpad" aria-label="Home">
      <mat-icon aria-hidden="true">home</mat-icon>
    </button>

    <button class="fl-navbar__icon" type="button" [matMenuTriggerFor]="quickNavMenu" aria-label="Quick navigation">
      <mat-icon aria-hidden="true">apps</mat-icon>
    </button>

    <button class="fl-navbar__icon" type="button" (click)="goToNewsFeed()" aria-label="Community feed">
      <mat-icon aria-hidden="true">rss_feed</mat-icon>
    </button>

    <button class="fl-navbar__icon" type="button" (click)="callFullscreen()" aria-label="Fullscreen">
      <mat-icon aria-hidden="true">fullscreen</mat-icon>
    </button>

    <ng-container *ngIf="authService.loggedInUser$ | async as user">
      <button class="fl-navbar__profile" type="button" [matMenuTriggerFor]="userMenu" aria-label="Open profile menu">
        <span class="fl-navbar__profile-copy">
          <strong>{{ getUserDisplayName(user) }}</strong>
          <small>{{ getUserRoleLabel(user) || 'User' }}</small>
        </span>
        <span class="fl-navbar__avatar">
          <img [src]="getUserAvatar(user)" alt="User avatar" />
        </span>
      </button>

      <mat-menu #userMenu="matMenu" xPosition="before" yPosition="below" class="fl-navbar-menu fl-navbar-menu--profile">
        <section class="fl-navbar-menu__identity" aria-label="Signed in user">
          <span class="fl-navbar-menu__avatar">
            <img [src]="getUserAvatar(user)" alt="" />
          </span>
          <div>
            <strong>{{ getUserDisplayName(user) }}</strong>
            <span>{{ getUserRoleLabel(user) || 'User' }}</span>
          </div>
        </section>

        <section class="fl-navbar-menu__meta" *ngIf="getUserEmail(user) || getUserFacilityName(user)">
          <p *ngIf="getUserEmail(user)">
            <mat-icon aria-hidden="true">mail</mat-icon>
            <span>{{ getUserEmail(user) }}</span>
          </p>
          <p *ngIf="getUserFacilityName(user)">
            <mat-icon aria-hidden="true">local_hospital</mat-icon>
            <span>{{ getUserFacilityName(user) }}</span>
          </p>
        </section>

        <mat-divider></mat-divider>

        <button mat-menu-item routerLink="/user/profile">
          <mat-icon aria-hidden="true">account_circle</mat-icon>
          <span>Profile</span>
        </button>
        <button
          *ngIf="isLaboratoryLevelUser(user)"
          mat-menu-item
          [routerLink]="['/user/profile']"
          [queryParams]="{ tab: 'facility' }">
          <mat-icon aria-hidden="true">local_hospital</mat-icon>
          <span>My Health Facility</span>
        </button>
        <button mat-menu-item (click)="logout()">
          <mat-icon aria-hidden="true">exit_to_app</mat-icon>
          <span>Logout</span>
        </button>
      </mat-menu>
    </ng-container>
  </nav>
</header>

<mat-menu #quickNavMenu="matMenu" xPosition="before" yPosition="below" class="fl-navbar-menu fl-navbar-menu--nav">
  <button mat-menu-item *ngFor="let item of quickNavItems" [routerLink]="item.route">
    <mat-icon aria-hidden="true">{{ item.icon }}</mat-icon>
    <span>{{ item.label }}</span>
  </button>
</mat-menu>
